import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import $i18n from "@/i18n";
import { router } from "@/main";

export const state = {
  unsaved: {},
};

export const getters = {
  unsaved: (state) => state.unsaved,
  isUnsaved: (state) => Object.keys(state.unsaved).length > 0,
};

export const mutations = {
  setUnsavedItem: (state, Payload) => {
    if (!state.unsaved[Payload.item]){
      state.unsaved[Payload.item] = [Payload.key];
    } else {
      if (!state.unsaved[Payload.item].includes(Payload.key)){
        state.unsaved[Payload.item].push(Payload.key);
      }
    }
    return state.unsaved;
  },

  removeUnsavedItem: (state, Payload) => {
    if (Payload.key){
      state.unsaved[Payload.item] = state.unsaved[Payload.item].filter(e => e !== Payload.key);
      if (state.unsaved[Payload.item].length < 1) {
        delete state.unsaved[Payload.item];
      }
    } else {
      delete state.unsaved[Payload.item];
    }
    return state.unsaved;
  },

  resetUnsaved: (state) => {
    state.unsaved = {};
    return state.unsaved;
  },
};

export const actions = {
  setUnsavedItem({ commit }, Payload) {
    commit("setUnsavedItem", Payload);
  },

  removeUnsavedItem({ commit }, Payload) {
    commit("removeUnsavedItem", Payload);
  },

  resetUnsaved({ commit, dispatch }) {
    commit("resetUnsaved");
  },
};
